import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from './store/'
import VuePlyr from 'vue-plyr'
// import 'vue-plyr/dist/vue-plyr.css' // only if your build system can import css, otherwise import it wherever you would import your css.
import VueMasonry from 'vue-masonry-css'
import 'vue-material-design-icons/styles.css'
// import Lottie from 'vue-lottie' // import lottie-vuejs
import MenuIcon from 'vue-material-design-icons/Menu.vue'
import GridIcon from 'vue-material-design-icons/Grid.vue'
import ListIcon from 'vue-material-design-icons/FormatListBulleted.vue'
import CloseIcon from 'vue-material-design-icons/WindowClose.vue'
import LinkedinIcon from 'vue-material-design-icons/LinkedinBox.vue'
import FacebookIcon from 'vue-material-design-icons/FacebookBox.vue'
import InstagramIcon from 'vue-material-design-icons/Instagram.vue'
import TwitterBox from 'vue-material-design-icons/TwitterBox.vue'
import Pen from 'vue-material-design-icons/Pen.vue'
import AccountGroup from 'vue-material-design-icons/AccountGroup.vue'
import ImageFrame from 'vue-material-design-icons/ImageFrame.vue'
import MapMarker from 'vue-material-design-icons/MapMarker.vue'

Vue.component('menu-icon', MenuIcon)
Vue.component('grid-icon', GridIcon)
Vue.component('list-icon', ListIcon)
Vue.component('close-icon', CloseIcon)
Vue.component('linkedin-icon', LinkedinIcon)
Vue.component('facebook-icon', FacebookIcon)
Vue.component('instagram-icon', InstagramIcon)
Vue.component('twitter-icon', TwitterBox)
Vue.component('pen-icon', Pen)
Vue.component('group-icon', AccountGroup)
Vue.component('image-frame-icon', ImageFrame)
Vue.component('map-marker-icon', MapMarker)
// Vue.use(Lottie) // add lottie-animation to your global scope
Vue.use(VuePlyr)
Vue.use(VueMasonry)
Vue.use(VueAxios, axios)

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')
